import type { FormikConfig } from "formik";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { z } from "@utils";
import type { IShapeOfForm } from "@/utils";

export interface IFormValues {
  amount: string;
}

const schema = z.object<IShapeOfForm<IFormValues>>({
  amount: z.coerce.number(),
});

export const formConfig: FormikConfig<IFormValues> = {
  initialValues: {
    amount: "",
  },
  validationSchema: toFormikValidationSchema(schema),
  validateOnChange: true,
  // only here for ts errors.
  onSubmit: () => {},
};
